module.exports = __webpack_public_path__ + "img/postbode.579a0673.png";